import Header from "./header";
import { useEffect, useState } from "react";
import {
  CatModHolder,
  PruebaVentanaCentrada,
  SkeletonLoader,
} from "./ProductHolder";
import Footer from "./Footer";
import ReactDOMServer from "react-dom/server";
import { CatSingleMod } from "./ProductHolder";
import { MonthContext } from "./ProductHolder";

import Announcements from "./Announcements";
export default function Catalogo() {
  const [items, setItems] = useState(10);
  const [mods, setMods] = useState([
    { name: "loading" },
    { name: "loading" },
    { name: "loading" },
    { name: "loading" },
    { name: "loading" },
    { name: "loading" },
    { name: "loading" },
    { name: "loading" },
    { name: "loading" },
  ]);
  const [total, setTotal] = useState(<p className="skeleton-subtitle"></p>);
  const [canBeUpdated, setUpdates] = useState(true);
  const [isDataLoaded, setIsLoading] = useState(false);
  const [locked, lock] = useState(true);
  const [eventTrigered, setTrigered] = useState(false);
  const [loading, setLoading] = useState();
  function loadAll() {
    if (canBeUpdated) {
      setUpdates(false);
      fetch(
        "https://api-legacy.mmods.es/v2/catalogo/get.php?limit=" +
          items +
          "&action=loadall",
        {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Content-type": "application/x-www-form-urlencoded",
          },
        },
      )
        .then((data) => data.json())
        .then((data) => {
          if (data.mods.length == 0) {
            setUpdates(false);
          }
          data.mods.map((mod) => {
            document
              .getElementById("all-mod-holder")
              .insertAdjacentHTML(
                "beforeend",
                ReactDOMServer.renderToString(
                  <CatSingleMod
                    month={mod.month}
                    created_text={mod.created_txt}
                    key={mod.id}
                    isNew={mod.new}
                    id={mod.id}
                    name={mod.name}
                    img={mod.img}
                    updated={mod.updated}
                    update_time={mod.update_time}
                    create_time={mod.created_time}
                    shoppy={mod.digitalshelf}
                  />,
                ),
              );
            if (mod.month) {
              document
                .querySelector("#month-mod-" + mod.id)
                .addEventListener("click", function () {
                  document.querySelector("#mensual-mod-context").className =
                    "supremo";
                });
            }
            document
              .getElementById("new-img-id-" + mod.id)
              .addEventListener("load", () => {
                const e = document.getElementById("new-img-id-" + mod.id);

                document.getElementById("new-skeleton-id-" + mod.id).remove();
                e.className = "product-img";
              });
            if (document.querySelector("#new-img-id-" + mod.id).complete) {
              const e = document.getElementById("new-img-id-" + mod.id);

              document.getElementById("new-skeleton-id-" + mod.id).remove();
              e.className = "product-img";
            }
          });
        });
    }
  }
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    if (eventTrigered == true && canBeUpdated && isDataLoaded) {
      setLoading(<Loading />);
      setTrigered(false);
      fetch("https://api-legacy.mmods.es/v2/catalogo/get.php?limit=" + items, {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Content-type": "application/x-www-form-urlencoded",
        },
      })
        .then((data) => data.json())
        .then((data) => {
          if (data.mods.length == 0) {
            setUpdates(false);
          }
          data.mods.map((mod) => {
            document
              .getElementById("all-mod-holder")
              .insertAdjacentHTML(
                "beforeend",
                ReactDOMServer.renderToString(
                  <CatSingleMod
                    month={mod.month}
                    created_text={mod.created_txt}
                    key={mod.id}
                    isNew={mod.new}
                    id={mod.id}
                    name={mod.name}
                    img={mod.img}
                    updated={mod.updated}
                    update_time={mod.update_time}
                    create_time={mod.created_time}
                    shoppy={mod.digitalshelf}
                  />,
                ),
              );
            if (mod.month) {
              document
                .querySelector("#month-mod-" + mod.id)
                .addEventListener("click", function () {
                  document.querySelector("#mensual-mod-context").className =
                    "supremo";
                });
            }
            document
              .getElementById("new-img-id-" + mod.id)
              .addEventListener("load", () => {
                const e = document.getElementById("new-img-id-" + mod.id);

                document.getElementById("new-skeleton-id-" + mod.id).remove();
                e.className = "product-img";
              });
            if (document.querySelector("#new-img-id-" + mod.id).complete) {
              const e = document.getElementById("new-img-id-" + mod.id);

              document.getElementById("new-skeleton-id-" + mod.id).remove();
              e.className = "product-img";
            }
          });
          setLoading(<></>);
        });
      window.addEventListener("scroll", handleScroll);
    }
  }, [items]);
  function handleScroll(item) {
    if (
      window.innerHeight + window.scrollY >=
      document.body.offsetHeight - 1000
    ) {
      setTrigered(true);
      setItems(items + 5);
    }
  }
  function filterMods() {
    loadAll(); //This functions loads all the items and inserts them into the body
    let input, filter, ul, li, a, i, txtValue, e;
    e = document.getElementById("search-input");
    filter = e.value.toUpperCase();
    ul = document.getElementById("all-mod-holder");
    li = ul.getElementsByClassName("search-content");

    // Loop through all list items, and hide those who don't match the search query
    for (i = 0; i < li.length; i++) {
      a = li[i];
      txtValue = a.textContent || a.innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        li[i].parentElement.parentElement.style.display = "";
      } else {
        li[i].parentElement.parentElement.style.display = "none";
      }
    }
  }
  useEffect((e) => {
    fetch(
      "https://api-legacy.mmods.es/v2/catalogo/get.php?action=initial_load",
      {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Content-type": "application/x-www-form-urlencoded",
        },
      },
    )
      .then((data) => data.json())
      .then((data) => {
        setMods(data.mods);
        setTotal(
          <p className="page-subtitle">
            Actualmente contamos con{" "}
            <span className="mmods-green">{data.total}</span> mods de pago
            disponibles
          </p>,
        );
        setIsLoading(true);
      });
  }, []);
  return (
    <>
      <MonthContext />
      <Header />
      <main id="items-wrapper" className="downloads-main-wrapper">
        <div className="page-title">
          <h1 className="">Cátalogo de mods de pago disponibles</h1>
          <p className="page-subtitle">
            Para obtener alguno puedes visitar nuestro perfil de{" "}
            <a href="https://mmods.link/digitalshelf">DigitalShelf</a> o
            contactar por privado.
          </p>
        </div>
        <div className="page-title flex-parent second-section-main">
          {total}
          <input
            onChange={(e) => {
              filterMods();
            }}
            onClick={(e) => {
              loadAll();
            }}
            className="search-input"
            id="search-input"
            type={"text"}
            placeholder={"Filtrar"}
          />
        </div>
        <span id={"all-mod-holder"} className="all-mod-holder">
          {mods.map((mod) => {
            return (
              <CatModHolder
                month={mod.month}
                created_text={mod.created_txt}
                loading={!isDataLoaded}
                key={mod.id}
                isNew={mod.new}
                id={mod.id}
                name={mod.name}
                img={mod.img}
                updated={mod.updated}
                update_time={mod.update_time}
                create_time={mod.created_time}
                shoppy={mod.digitalshelf}
              />
            );
          })}
        </span>
        {loading}
      </main>
      <Footer />
    </>
  );
}

function Loading() {
  return (
    <mmods_loader className="loadder-wrapper">
      <div class="dot-spinner">
        <div class="dot-spinner__dot"></div>
        <div class="dot-spinner__dot"></div>
        <div class="dot-spinner__dot"></div>
        <div class="dot-spinner__dot"></div>
        <div class="dot-spinner__dot"></div>
        <div class="dot-spinner__dot"></div>
        <div class="dot-spinner__dot"></div>
        <div class="dot-spinner__dot"></div>
      </div>
    </mmods_loader>
  );
}
